import React, { useContext, useRef, useState, useEffect } from "react";
import { AdminContext } from "../../contexts/contexAdmin";
import { FaUserAlt } from "react-icons/fa";
import { AdminPage } from "../../styles/admin";
import { Footer } from "../../components/footer";
import { AdminUser } from "./adminUser";
import {
  BombasTanques,
  CreatingTanque,
  CreatingUser,
  ModalConfirmChangesTanque,
  ModalConfirmDeleteUser,
  ModalUpdatePassword,
  ModalUpdateUser,
} from "./modalAdmin";
import { SquareLoading } from "../../components/loaders";
import { Header2 } from "../../components/header";
import imgTanque2 from "../../assets/icons/Novotanque.png";
import { TanqueAdmin } from "./tanqueAdmin";
import { HeaderMobile } from "../../components/mobileHeader";
import { useBodyScrollLock } from "../../hooks/useBodyScrollLock";

export const PageAdmin = () => {
  const {
    adminPage,
    setAdminPage,
    modalCreatingUser,
    modalUserDeletConfirmation,
    modaUpdatePassword,
    modalEditUser,
    loading,
    modalConfimation,
    modalBombaTanque,
    salveTanqueInfo,
    modalCreatTanque,
  } = useContext(AdminContext);

  const [activeTab, setActiveTab] = useState(0);
  const [indicatorPosition, setIndicatorPosition] = useState({
    left: 0,
    width: 0,
  });

  const hasOpenAdminModal = Boolean(
    modalCreatingUser ||
      modalUserDeletConfirmation ||
      modaUpdatePassword ||
      modalEditUser ||
      modalConfimation ||
      modalBombaTanque ||
      modalCreatTanque,
  );

  useBodyScrollLock(hasOpenAdminModal);

  const indicatorRef = useRef(null);

  useEffect(() => {
    if (activeTab !== null && indicatorRef.current) {
      const activeElement = indicatorRef.current.children[activeTab];
      setIndicatorPosition({
        left: activeElement.offsetLeft,
        width: activeElement.offsetWidth,
      });
    }
  }, [activeTab]);

  const handleTabClick = (index, pageName) => {
    setActiveTab(index);
    setAdminPage(pageName);
  };

  return (
    <AdminPage>
      {/* <Header tanque={true} motobomba={false} /> */}
      <Header2 />
      <HeaderMobile />
      {loading ? <SquareLoading /> : null}
      {modalCreatingUser && <CreatingUser />}
      {modalUserDeletConfirmation && <ModalConfirmDeleteUser />}
      {modaUpdatePassword && <ModalUpdatePassword />}
      {modalEditUser && <ModalUpdateUser />}
      {modalConfimation && <ModalConfirmChangesTanque />}
      {modalBombaTanque && <BombasTanques tanqueInfo={salveTanqueInfo} />}
      {modalCreatTanque && <CreatingTanque />}

      <nav>
        <ul className="nav-list" ref={indicatorRef}>
          <li
            onClick={() => handleTabClick(0, "User")}
            className={`nav-item ${adminPage === "User" ? "active" : ""}`}
          >
            <FaUserAlt />
          </li>
          <li
            onClick={() => handleTabClick(1, "Tanque")}
            className={`nav-item ${adminPage === "Tanque" ? "active" : ""}`}
          >
            <img src={imgTanque2} alt="" />
          </li>
        </ul>
        <div className="nav-indicator" style={indicatorPosition}></div>
      </nav>
      {adminPage === "User" && <AdminUser />}
      {adminPage === "Tanque" && <TanqueAdmin />}
      <Footer relative={false} />
    </AdminPage>
  );
};
